import * as apiPost from 'api/orderGuide/PostErpOrderGuideV1';
import * as Direction from 'types/Recipe/Detail/ErpNew/Direction';

export type Type = Direction.Type[];

export function create(): Type {
	return [];
}

export function mapFromApiPost(input: apiPost.Product[]): Type {
	return input.map(Direction.mapFromApiPost);
}

export function getAllProductIds(obj: Type) {
	return obj.map((e) => e.productId);
}
